import { render, staticRenderFns } from "./CancelContract.vue?vue&type=template&id=1f084c0f&scoped=true&"
import script from "./CancelContract.vue?vue&type=script&lang=ts&"
export * from "./CancelContract.vue?vue&type=script&lang=ts&"
import style0 from "./CancelContract.vue?vue&type=style&index=0&id=1f084c0f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f084c0f",
  null
  
)

export default component.exports